module.exports = __webpack_public_path__ + "static/media/GalleryMain6.a2b332b9.jpg";